/* BEZELOR desktop menu bar. Dropdowns open on hover (mouse only, short intent delay), close after a short
   grace period with a fade, and moving between menus switches instantly. Click, touch and keyboard keep the
   native <details> behaviour; Esc closes. Styles: assets/bezelor-nav.css */
(() => {
  if (window.__bzNav) return;
  window.__bzNav = true;
  const mouse = matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const OPEN = 70, CLOSE = 160, OUT = 140;
  let current = null;

  const shut = (d, instant) => {
    if (!d || !d.open) return;
    clearTimeout(d._bzt);
    if (current === d) current = null;
    if (instant || reduce.matches) { d.classList.remove('bzn-closing'); d.open = false; return; }
    d.classList.add('bzn-closing');
    d._bzt = setTimeout(() => { d.classList.remove('bzn-closing'); d.open = false; }, OUT);
  };
  const show = (d) => {
    clearTimeout(d._bzt);
    d.classList.remove('bzn-closing');
    if (current && current !== d) shut(current, true);
    current = d;
    if (!d.open) { d.open = true; d._bzHoverAt = Date.now(); }
  };

  const bind = (d) => {
    if (d._bzn) return;
    d._bzn = true;
    const list = d.querySelector('.header__submenu');
    if (list && list.children.length > 8) list.classList.add('bzn-cols');
    d.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse' || !mouse.matches) return;
      clearTimeout(d._bzt);
      d._bzt = setTimeout(() => show(d), current ? 0 : OPEN);
    });
    d.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse' || !mouse.matches) return;
      clearTimeout(d._bzt);
      d._bzt = setTimeout(() => shut(d), CLOSE);
    });
    /* a click right after hover-open would close it again: keep it open instead */
    d.querySelector('summary').addEventListener('click', (e) => {
      if (d.open && d._bzHoverAt && Date.now() - d._bzHoverAt < 700) e.preventDefault();
      d._bzHoverAt = 0;
    });
    d.addEventListener('toggle', () => { if (d.open && current !== d) { if (current) shut(current, true); current = d; } });
    d.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && d.open) { shut(d, true); d.querySelector('summary').focus(); }
    });
  };

  /* Copy the bar's own background into variables the dropdown shares (see "Same glass" in bezelor-nav.css).
     Desktop only: phones have no dropdowns and keep the bar exactly as styled. The class is lifted for one
     synchronous style read, so nothing flashes. */
  const desk = matchMedia('(min-width: 990px)');
  const syncGlass = () => {
    const w = document.querySelector('.section-header sticky-header.header-wrapper');
    if (!w) return;
    w.classList.remove('bzh-glass');
    if (desk.matches) {
      const c = getComputedStyle(w);
      w.style.setProperty('--bzh-c', c.backgroundColor);
      w.style.setProperty('--bzh-i', c.backgroundImage);
      w.style.setProperty('--bzh-f', c.backdropFilter || c.webkitBackdropFilter || 'none');
      if (!w.querySelector(':scope > .bzh-glass-layer')) {
        const layer = document.createElement('span');
        layer.className = 'bzh-glass-layer';
        layer.setAttribute('aria-hidden', 'true');
        w.prepend(layer);
      }
      w.classList.add('bzh-glass');
    }
    if (wObs) wObs.takeRecords(); /* ignore our own class flip */
  };
  let wObs = null;
  let glassFrame = 0;
  const queueGlass = () => { if (!glassFrame) glassFrame = requestAnimationFrame(() => { glassFrame = 0; syncGlass(); }); };
  const watchGlass = () => {
    syncGlass();
    const sec = document.querySelector('.section-header');
    if (sec && 'MutationObserver' in window) {
      const mo = new MutationObserver(queueGlass);
      mo.observe(sec, { attributes: true, attributeFilter: ['class'] });
      const w = sec.querySelector('sticky-header');
      if (w) { wObs = new MutationObserver(queueGlass); wObs.observe(w, { attributes: true, attributeFilter: ['class'] }); }
    }
    window.addEventListener('resize', queueGlass);
    desk.addEventListener?.('change', queueGlass);
  };

  const init = () => { document.querySelectorAll('.bz-nav details').forEach(bind); if (!window.__bzGlass) { window.__bzGlass = true; watchGlass(); } };
  document.addEventListener('click', (e) => { if (current && !current.contains(e.target)) shut(current); });
  window.addEventListener('scroll', () => { if (current && mouse.matches) shut(current); }, { passive: true });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
